import { createAction, props } from '@ngrx/store';

import { CompanySettingsApiModel, MwCorePreferenceModel } from '../../models';

const ID = '[Company] ';

export const requestCompanySettings = createAction(
  `${ID}Request company settings`,
  props<{ companyId: number }>()
);

export const companySettingsReceived = createAction(
  `${ID}Company settings received`,
  props<{ settings: CompanySettingsApiModel }>()
);

export const companySettingsReceiveFailed = createAction(
  `${ID}Company settings receive failed`,
  props<{ err: any }>()
);

export const requestPreference = createAction(
  `${ID}Request preference`,
  props<{ companyId: number }>()
);

export const preferenceReceived = createAction(
  `${ID}Preference received`,
  props<{ data: MwCorePreferenceModel }>()
);

export const preferenceReceiveFailed = createAction(
  `${ID}Preference receive failed`,
  props<{ err: any }>()
);

export const savePreference = createAction(
  `${ID}Save preference`,
  props<{ data: any }>()
);

export const preferenceSaved = createAction(
  `${ID}Preference saved`,
  props<{ data: MwCorePreferenceModel }>()
);

export const preferenceSaveFailed = createAction(
  `${ID}Preference save failed`,
  props<{ err: any }>()
);

export const clearPreference = createAction(`${ID}Clear preference`);

export const preferenceCleared = createAction(`${ID}Preference cleared`);

export const preferenceClearFailed = createAction(
  `${ID}Preference clear failed`,
  props<{ err: any }>()
);

export const requestFeatureFlagState = createAction(
  `${ID}Request feature flag`,
  props<{ key: string; companyId: number }>()
);

export const featureFlagReceived = createAction(
  `${ID}Feature flag received`,
  props<{ key: string; companyId: number; isEnabled: boolean }>()
);

export const featureFlagReceiveFailed = createAction(
  `${ID}Feature flag receive failed`,
  props<{ err: any }>()
);
